import * as firebase from "firebase";
import { reset } from "redux-form";
import _ from "lodash";

// Products
export const FETCH_PRODUCT = "fetch_product";
export const FETCH_PRODUCT_SUCCESS = "fetch_product_success";
export const FETCH_PRODUCT_FAIL = "fetch_product_fail";

export const FETCH_PRODUCTS = "fetch_products";
export const FETCH_PRODUCTS_SUCCESS = "fetch_products_success";
export const FETCH_PRODUCTS_FAIL = "fetch_products_fail";

export const ADD_PRODUCT = "add_product";
export const ADD_PRODUCT_SUCCESS = "add_product_success";
export const ADD_PRODUCT_FAIL = "add_product_fail";

export const UPDATE_PRODUCT = "update_product";
export const UPDATE_PRODUCT_SUCCESS = "update_product_success";
export const UPDATE_PRODUCT_FAIL = "update_product_fail";

export const DELETE_PRODUCT = "delete_product";
export const DELETE_PRODUCT_SUCCESS = "delete_product_success";
export const DELETE_PRODUCT_FAIL = "delete_product_fail";

export const UPDATE_PRODUCT_ORDER = "update_product_order";
export const UPDATE_PRODUCT_ORDER_SUCCESS = "update_product_order_success";
export const UPDATE_PRODUCT_ORDER_FAIL = "update_product_order_fail";

// Promotions
export const FETCH_PROMOTIONS = "fetch_promotions";
export const FETCH_PROMOTIONS_SUCCESS = "fetch_promotions_success";

export const FETCH_PROMOTION = "fetch_single_promotion";
export const FETCH_PROMOTION_SUCCESS = "fetch_single_promotion_success";
export const FETCH_PROMOTION_FAIL = "fetch_single_promotion_fail";

export const ADD_PROMOTION = "add_promotion";
export const ADD_PROMOTION_SUCCESS = "add_promotion_success";
export const ADD_PROMOTION_FAIL = "add_promotion_fail";

export const UPDATE_PROMOTION = "update_promotion";
export const UPDATE_PROMOTION_SUCCESS = "update_promotion_success";
export const UPDATE_PROMOTION_FAIL = "update_promotion_fail";

export const DELETE_PROMOTION = "delete_promotion";
export const DELETE_PROMOTION_SUCCESS = "delete_promotion_success";
export const DELETE_PROMOTION_FAIL = "delete_promotion_fail";

// Highlight Products
export const FETCH_HIGHLIGHT_PRODUCTS = "fetch_highlight_products";
export const FETCH_HIGHLIGHT_PRODUCTS_SUCCESS =
  "fetch_highlight_products_success";

export const FETCH_HIGHLIGHT_PRODUCT = "fetch_highlight_product";
export const FETCH_HIGHLIGHT_PRODUCT_SUCCESS =
  "fetch_highlight_product_success";
export const FETCH_HIGHLIGHT_PRODUCT_FAIL = "fetch_highlight_product_fail";

export const ADD_HIGHLIGHT_PRODUCT = "add_new_highlight_products";
export const ADD_HIGHLIGHT_PRODUCT_SUCCESS =
  "add_new_highlight_products_success";

export const UPDATE_HIGHLIGHT_PRODUCTS = "update_highlight_products";
export const UPDATE_HIGHLIGHT_PRODUCTS_SUCCESS =
  "update_highlight_products_success";

export const GET_HIGHLIGHT_PRODUCT_IMAGE_SUCCESS =
  "get_highlight_product_image_success";

export const DELETE_HIGHLIGHT_PRODUCT = "delete_highlight_product";
export const DELETE_HIGHLIGHT_PRODUCT_SUCCESS =
  "delete_highlight_product_success";
export const DELETE_HIGHLIGHT_PRODUCT_FAIL = "delete_highlight_product_fail";

export const SET_HIGHLIGHT_PRODUCT = "set_highlight_product";

export const UPDATE_HIGHLIGHT_PRODUCTS_DESC = "update_highlight_products_desc";

export function fetchProductDetail(id, callback) {
  const productRef = firebase
    .database()
    .ref("products")
    .child(id);

  return (dispatch) => {
    dispatch({
      type: FETCH_PRODUCT,
    });

    productRef
      .once("value", (snapshot) => {
        const product = snapshot.val();

        // console.log(product);

        dispatch({
          type: FETCH_PRODUCT_SUCCESS,
          payload: {
            key: snapshot.key,
            value: {
              ...product,
              id: snapshot.key,
            },
          },
        });

        if (callback) {
          callback(product);
        }
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: FETCH_PRODUCT_FAIL,
        });
        if (callback) {
          callback(null);
        }
      });
  };
}

// update

// delete

export function fetchAllProducts() {
  const productsRef = firebase.database().ref("products");

  return (dispatch) => {
    dispatch({
      type: FETCH_PRODUCTS,
    });

    productsRef.on("value", (snapshot) => {
      // const values = snapshot.val();

      if (snapshot.numChildren() > 0) {
        // let rawProducts = [];
        let rawProducts = {};
        snapshot.forEach((rawProduct) => {
          rawProducts[rawProduct.key] = {
            ...rawProduct.val(),
            id: rawProduct.key,
          };
        });

        dispatch({
          type: FETCH_PRODUCTS_SUCCESS,
          payload: rawProducts,
        });
      } else {
        console.log("No products in db!");
      }
    });
  };
}

export function fetchAllPromotions() {
  const promotionsRef = firebase.database().ref("promotions");

  return (dispatch) => {
    dispatch({
      type: FETCH_PROMOTIONS,
    });

    promotionsRef.on("value", (snapshot) => {
      if (snapshot) {
        dispatch({
          type: FETCH_PROMOTIONS_SUCCESS,
          payload: snapshot.val(),
        });
      }
    });
  };
}

export function fetchPromotion(id) {
  const promotionRef = firebase
    .database()
    .ref("promotions")
    .child(id);

  return (dispatch) => {
    dispatch({
      type: FETCH_PROMOTION,
    });

    promotionRef
      .once("value")
      .then((snapshot) => {
        const value = snapshot.val();
        if (value) {
          dispatch({
            type: FETCH_PROMOTION_SUCCESS,
            payload: {
              promotion: value,
              id: id,
            },
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_PROMOTION_FAIL,
          payload: error.message,
        });
      });
  };
}

export function updatePromotion(promotion, finishCallback) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_PROMOTION,
    });

    let promotionId = promotion.id;
    if (!promotion.id) {
      promotionId = firebase
        .database()
        .ref("promotions")
        .push().key;
    }

    let promotionRef = firebase
      .database()
      .ref("promotions")
      .child(promotionId);

    let updatePromotionObj = {
      ...promotion,
    };
    updatePromotionObj.id = promotionId;
    promotionRef.update(updatePromotionObj, (error) => {
      if (error) {
        dispatch({
          type: UPDATE_PROMOTION_FAIL,
        });
      } else {
        dispatch({
          type: UPDATE_PROMOTION_SUCCESS,
        });
        dispatch(reset("PromotionForm"));
      }

      if (finishCallback) {
        finishCallback();
      }
    });

    console.log(promotion);
  };
}

export function deletePromotion(id) {}

// Highlight Products

export function fetchAllHighlightProducts() {
  const highlightProductsRef = firebase.database().ref("highlight_products");

  return (dispatch) => {
    dispatch({
      type: FETCH_HIGHLIGHT_PRODUCTS,
    });

    highlightProductsRef.on("value", (snapshot) => {
      const value = snapshot.val();

      if (value) {
        let rawHighlights = [];
        snapshot.forEach((rawHighlight) => {
          const highlightId = rawHighlight.key;
          const highlightValue = rawHighlight.val();
          rawHighlights.push({
            ...highlightValue,
            highlightId: highlightId,
          });
        });

        rawHighlights.sort((a, b) => {
          return a.order - b.order;
        });

        dispatch({
          type: FETCH_HIGHLIGHT_PRODUCTS_SUCCESS,
          payload: value,
          sortedPayload: rawHighlights,
        });
      }
    });
  };
}

export function fetchHighlightProduct(id) {
  const highlightProductRef = firebase
    .database()
    .ref("highlight_products")
    .child(id);

  return (dispatch) => {
    dispatch({
      type: FETCH_HIGHLIGHT_PRODUCT,
    });

    highlightProductRef
      .once("value")
      .then((snapshot) => {
        const value = snapshot.val();
        if (value) {
          dispatch({
            type: FETCH_HIGHLIGHT_PRODUCT_SUCCESS,
            payload: {
              id: id,
              highlightProduct: value,
            },
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_HIGHLIGHT_PRODUCT_FAIL,
          payload: error.message,
        });
      });
  };
}

export function addHighlightProduct(highlight, shortDesc, callback) {
  // set order
  const highlightRef = firebase
    .database()
    .ref("highlight_products")
    .push();
  const highlightId = highlightRef.key;

  // // order:
  // // product_id:
  // // +
  // // image_name:
  // const extension = file.name.split('.').pop();
  // const imageName = `${highlightId}.${extension}`;

  let newHighlight = {
    ...highlight,
    short_desc: shortDesc,
    id: highlightId,
  };

  return (dispatch) => {
    dispatch({
      type: ADD_HIGHLIGHT_PRODUCT,
    });

    highlightRef
      .update(newHighlight)
      .then(() => {
        dispatch({
          type: ADD_HIGHLIGHT_PRODUCT_SUCCESS,
        });

        if (callback) {
          callback(true);
        }
      })
      .catch((error) => {
        console.log(error.message);
        if (callback) {
          callback(false, error.message);
        }
      });
  };
}

export function deleteHighlightProduct(id, callback) {
  return (dispatch) => {
    dispatch({ type: DELETE_HIGHLIGHT_PRODUCT });

    const highlightRef = firebase
      .database()
      .ref("highlight_products")
      .child(id);
    highlightRef
      .remove()
      .then(() => {
        dispatch({ type: DELETE_HIGHLIGHT_PRODUCT_SUCCESS });

        if (callback) {
          callback(true);
        }
      })
      .catch((error) => {
        dispatch({
          type: DELETE_HIGHLIGHT_PRODUCT_FAIL,
          payload: error.message,
        });

        if (callback) {
          callback(false);
        }
      });
  };
}

/**
 * files = {
 *  id: {
 *    file: file,
 *    uploaded: false
 *  },
 *
 * }
 *
 *
 */

// recursive
function uploadFiles(
  { files, uploadPath, namePrefix, dbProductId },
  progressCallback,
  finishCallback
) {
  // use select file from files
  const nextFile = _.find(files, ["uploaded", false]);
  if (nextFile) {
    performUpload(
      {
        file: nextFile.file,
        uploadPath,
        namePrefix,
        dbProductId,
      },
      (progress) => {
        if (progressCallback) {
          progressCallback(nextFile, progress);
        }
      },
      ({ fileName, url }) => {
        // mark this file as uploaded
        nextFile.uploaded = true;
        nextFile.uploadedURL = url;
        nextFile.uploadedFileName = fileName;
        const updatedFiles = {
          ...files,
          [nextFile.id]: nextFile,
        };

        uploadFiles(
          {
            files: updatedFiles,
            uploadPath,
            namePrefix,
            dbProductId,
          },
          progressCallback,
          finishCallback
        );
      }
    );
  } else {
    // all files are uploaded
    // send all file urls

    // end recursive
    if (finishCallback) {
      finishCallback(files);
    }
  }
}

function performUpload(
  { file, uploadPath, namePrefix, dbProductId },
  progressCallback,
  finishCallback
) {
  // get file extensions
  // put it in file name
  // also put it in database-> image_name
  const extension = file.name.split(".").pop();
  const fileName = `${namePrefix}_${Date.now()}.${extension}`;
  const metadata = {
    customMetadata: {
      productId: dbProductId,
    },
  };

  const bucketRef = firebase
    .storage()
    .ref()
    .child(uploadPath);
  const fileRef = bucketRef.child(fileName);
  let uploadTask = fileRef.put(file, metadata);

  uploadTask.on(
    firebase.storage.TaskEvent.STATE_CHANGED,
    (snapshot) => {
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

      console.log("Upload is " + progress + "% done");
      if (progressCallback) {
        progressCallback(progress);
      }

      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log("Upload is paused");
          break;
        case firebase.storage.TaskState.RUNNING: // or 'running'
          // console.log('Upload is running');
          break;
      }
    },
    (error) => {
      // A full list of error codes is available at
      // https://firebase.google.com/docs/storage/web/handle-errors
      switch (error.code) {
        case "storage/unauthorized":
          // User doesn't have permission to access the object
          break;

        case "storage/canceled":
          // User canceled the upload
          break;

        case "storage/unknown":
          // Unknown error occurred, inspect error.serverResponse
          break;
      }

      if (finishCallback) {
        finishCallback(null, error);
      }
    },
    () => {
      // Upload completed successfully, now we can get the download URL
      if (finishCallback) {
        finishCallback({
          fileName,
          url: uploadTask.snapshot.downloadURL,
        });
      }
      // addFilePath(sessionId, file.name, fileRef.fullPath);
    }
  );
}

export function updateHighlightProducts(products) {
  console.log("updateHighlightProducts", products);
  // array
  const highlightRef = firebase.database().ref("highlight_products");

  return (dispatch) => {
    dispatch({
      type: UPDATE_HIGHLIGHT_PRODUCTS,
    });

    products.map((p, index) => {
      console.log(p);
      highlightRef.child(p.highlightId).update({
        order: index,
      });
    });
  };
}

export function updateHighlightProductsDesc(highlightId, desc, callback) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_HIGHLIGHT_PRODUCTS_DESC,
    });
    const highlightRef = firebase
      .database()
      .ref("highlight_products")
      .child(highlightId)
      .update({
        short_desc: {
          en: desc.short_desc_en,
          th: desc.short_desc_th,
          zh: desc.short_desc_zh,
        },
      })
      .then(() => {
        if (callback) {
          callback();
        }
      });
  };
}

export function setHighlightProduct(product) {
  console.log("setHighlightProduct", product);
  // array
  const highlightRef = firebase.database().ref("highlight_products");

  return (dispatch) => {
    dispatch({
      type: SET_HIGHLIGHT_PRODUCT,
      payload: product,
    });
  };
}

export function getProductImage(imageName, callback) {
  const productImageRef = firebase
    .storage()
    .ref()
    .child("public/images/products")
    .child(imageName);

  return (dispatch) => {
    productImageRef
      .getDownloadURL()
      .then((url) => {
        console.log(url);
        if (callback) {
          callback(url);
        }
      })
      .catch((error) => {
        console.log(error.message);
      });
  };
}

export function getHighlightProductImage(id, imageName, callback) {
  const productImageRef = firebase
    .storage()
    .ref()
    .child("public/images/highlightProducts")
    .child(imageName);

  return (dispatch) => {
    productImageRef
      .getDownloadURL()
      .then((url) => {
        console.log(url);
        if (callback) {
          callback(url);
        }
        if (url) {
          dispatch({
            type: GET_HIGHLIGHT_PRODUCT_IMAGE_SUCCESS,
            payload: {
              id: id,
              url: url,
            },
          });
        }
      })
      .catch((error) => {
        console.log(error.message);
      });
  };
}

export function deleteHighlightPorduct(highlight, callback) {
  const bucketRef = firebase
    .storage()
    .ref()
    .child("public/images/highlightProducts")
    .child(highlight.image_name);

  return (dispatch) => {
    // highlightRef.remove()
    bucketRef
      .delete()
      .then(() => {
        // success
        const highlightRef = firebase
          .database()
          .ref("highlight_products")
          .child(highlight.highlightId);
        highlightRef
          .remove()
          .then(() => {})
          .catch((error) => {});
      })
      .catch((error) => {});
  };
}

// Product

export function addProduct(
  product,
  imageFiles,
  progressCallback,
  finishCallback
) {
  return (dispatch) => {
    dispatch({
      type: ADD_PRODUCT,
    });

    // 1. Update product images
    const files = {};
    const fileObjects = _.filter(imageFiles, (image) => image instanceof File);
    _.map(fileObjects, (file, index) => {
      const fileId = `F${index}`;
      files[fileId] = {
        file,
        id: fileId,
        uploaded: false,
      };
    });
    // create file reference
    const dbProductId = firebase
      .database()
      .ref("products")
      .push().key;

    uploadFiles(
      {
        files,
        uploadPath: "public/images/products",
        namePrefix: product.sku,
        dbProductId,
      },
      progressCallback,
      (uploadedFiles) => {
        // collection of uploaded files
        console.log(uploadedFiles);

        // 2. Write product data to database
        writeProductToDatabase(
          {
            product,
            dbProductId,
          },
          uploadedFiles,
          dispatch,
          finishCallback
        );
      }
    );
  };
}

export function updateProduct(
  { product, id, imageFiles },
  progressCallback,
  finishCallback
) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_PRODUCT,
    });
    // 1 clean image_paths
    const productImageRef = firebase
      .database()
      .ref("products/" + id + "/image_paths");
    productImageRef.set({});
    // 2 map product image_paths ให้เป็นปัจจุบัน
    const notTypeFile = _.filter(
      imageFiles,
      (image) => !(image instanceof File)
    );
    let imagePathsOld = {};
    for (let index = 0; index < notTypeFile.length; index++) {
      const value = notTypeFile[index];
      imagePathsOld[value["imageId"]] = {
        thumb_url: value["preview"],
        url: value["preview"],
      };
    }
    product.image_paths = imagePathsOld;

    // 1. Update product images
    const files = {};
    const fileObjects = _.filter(imageFiles, (image) => image instanceof File);
    _.map(fileObjects, (file, index) => {
      const fileId = `F${index}`;
      files[fileId] = {
        file,
        id: fileId,
        uploaded: false,
      };
    });

    uploadFiles(
      {
        files,
        uploadPath: "public/images/products",
        namePrefix: product.sku,
        dbProductId: id,
      },
      progressCallback,
      (uploadedFiles) => {
        // collection of uploaded files
        console.log(uploadedFiles);

        // 2. Write product data to database
        writeProductToDatabase(
          {
            product,
            dbProductId: id,
          },
          uploadedFiles,
          dispatch,
          finishCallback
        );
      }
    );
  };
}

function writeProductToDatabase(
  { product, dbProductId },
  uploadedFiles,
  dispatch,
  callback
) {
  const productRef = firebase
    .database()
    .ref("products")
    .child(dbProductId);

  let imagePaths = product.image_paths ? product.image_paths : {};
  let updateProduct = product;
  if (Object.keys(uploadedFiles).length != 0) {
    for (const [keys, value] of Object.entries(uploadedFiles)) {
      imagePaths[value["uploadedFileName"].replace(".", "-")] = {
        thumb_url: value["uploadedURL"],
        url: value["uploadedURL"],
      };
    }
    updateProduct = {
      ...product,
      image_paths: imagePaths,
    };
  }

  productRef.update(updateProduct, (error) => {
    if (error) {
      dispatch({
        type: ADD_PRODUCT_FAIL,
      });
    } else {
      dispatch({
        type: ADD_PRODUCT_SUCCESS,
      });
      dispatch(reset("ProductForm"));
    }

    if (callback) {
      callback();
    }
  });
}
export function deleteProduct(productId, callback) {
  return (dispatch) => {
    dispatch({
      type: DELETE_PRODUCT,
    });

    const productStatusRef = firebase
      .database()
      .ref("products")
      .child(productId)
      .child("status");
    // don't actually delete
    // just set status to 3
    const status = 3;

    productStatusRef.set(status, (error) => {
      if (error) {
        dispatch({
          type: DELETE_PRODUCT_FAIL,
          payload: error.message,
        });
      } else {
        dispatch({
          type: DELETE_PRODUCT_SUCCESS,
        });
      }
      if (callback) {
        callback(error);
      }
    });
  };
}

function getProductImageURL(imageName, callback) {
  const productImageRef = firebase
    .storage()
    .ref()
    .child("public/images/products")
    .child(`thumb_${imageName}`);

  productImageRef
    .getDownloadURL()
    .then((url) => {
      console.log(url);
      if (callback) {
        callback(url);
      }
    })
    .catch((error) => {
      console.log(error.message);
    });
}



// WEBPACK FOOTER //
// ./src/actions/Product.js